import React from 'react';
import RootElement from './src/components/root-elemente';
import './src/styles/global.css';

export const wrapRootElement = ({ element }) => {
  return <RootElement>{element}</RootElement>;
};
